/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit'
import { get } from 'utils/lodash'

const initialState = {
  unmatchConfirmationDialog: { isOpen: false, payload: [] },
}

const disposalTicketsReviewSlice = createSlice({
  name: 'disposalTicketsReview',
  initialState: { ...initialState },
  reducers: {
    setUnmatchConfirmationDialogState: (state, action) => {
      state.unmatchConfirmationDialog = action.payload
    },
    resetState: () => initialState,
  },
})

export const { setUnmatchConfirmationDialogState, resetState } = disposalTicketsReviewSlice.actions

export const selectUnmatchConfirmationDialogState = state =>
  get(state, 'disposalTicketsReview.unmatchConfirmationDialog', initialState.unmatchConfirmationDialog)

export default disposalTicketsReviewSlice.reducer
